import { createFileRoute } from "@tanstack/react-router";

import { AdminKakekomiListPage } from "@/features/admin/kakekomi/kakekomi-list-page";
import { adminKakekomiEventsQueryOptions } from "@/features/admin/kakekomi/queries";
import { STATIC_LABELS } from "@/lib/nav-registry";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/kakekomi/")({
  staticData: { crumb: { label: STATIC_LABELS.adminKakekomi } },
  loader: ({ context }) => context.queryClient.ensureQueryData(adminKakekomiEventsQueryOptions()),
  component: AdminKakekomiListPage,
});
